var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 201 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M100.333 183.667C54.308 183.667 17 146.358 17 100.333S54.308 17 100.333 17s83.334 37.308 83.334 83.333-37.309 83.334-83.334 83.334m0-16.667a66.67 66.67 0 0 0 47.141-19.526 66.67 66.67 0 0 0 0-94.281 66.67 66.67 0 0 0-94.281 0A66.666 66.666 0 0 0 100.333 167m-14.175-39.2-23.6-23.6a8.334 8.334 0 1 1 11.784-11.783L92.025 110.1l37.125-36.717a8.384 8.384 0 0 1 11.825.034 8.29 8.29 0 0 1 2.432 5.884 8.28 8.28 0 0 1-2.457 5.874l-43.033 42.658a8.33 8.33 0 0 1-11.759-.025z"
  })));
};
export default SvgRight;